import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comicroom',
  templateUrl: './comicroom.component.html',
  styleUrls: ['./comicroom.component.scss']
})
export class ComicroomComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
